import { validationTypes } from '../../../../../commons/validations';

export const registerInput = ({ register, name, options = {}, type = '' }) => {
  return register(name, {
    ...validationTypes[type ? type : name],
    ...options,
  });
};
